import revsCommon from './revsCommon'

export default {
  ...revsCommon,
  problem: item => item?.problemAnalysis?.problem ?? '',
  plan: item => item?.problemAnalysis?.containment ?? '',
  solution: item => item?.solutionDescription ?? '',
}
